const Category = {

    // FIELDS
    "name": "Name",
    "image": "Image",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "category": "Category",

    // ERROR
    "error_name": "Enter Name",
    "error_image": "Select Image",
    "error_description": "Enter Description",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_image": "IMAGE",
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",

    // OTHER
    "current_image": "Current Image",

}

export default Category;

